export default {
  login: "Login ဝင်ပါ...",
  password_rule: "* စကားဝှက်အား အကြီးအသေးနှင့် အနည်းဆုံး ၆ လုံးမှ ၁၀ လုံးထားပါ.",
  nickname_rule: "* သင်၏ Nick Name အား ၆လုံးမှ ၁၅ လုံးအထိနှင့် တစ်ကြိမ်သာ ထားရှိနိုင်သည်.",
  change_password_succeed: "စကားဝှက် ပြုပြင်ခြင်းအောင်မြင်သည်.",
  add_secondary_succeed: "Nick Name ပြုလုပ်ခြင်းအောင်မြင်သည်.",
  succeed: "သင်၏ လုပ်ဆောင်ချက် အောင်မြင်သည်!",
  failed: "သင်၏ လုပ်ဆောင်ချက် မအောင်မြင်ပါ!",
  no_information_available: "သတင်းအချက်အလက်မရှိပါ.",
  select_display_language: "အသုံးပြုလိုသည့် ဘာသာစကား ရွေးချယ်ပါ.",
  select_odds_type: "ကစားလိုသည့် ပေါက်ကြေးအမျိုးအစား ရွေးချယ်ပါ.",
  select_page_type: "ယနေ့ (သို့) မနက်ဖြန် ကစားမည့် စာမျက်နှာကို ရွေးချယ်ပါ.",
  select_show_score_map: "လောင်းထားသည့် ကစားပွဲများအား စနစ်မှ အနိုင်အရှုံးဖော်ပြချက်များကို ဇယားပုံနှင့်တကွ အလိုအလျောက် ပြသပေးမည်.",
  select_default_event_sorting: "အမြဲတမ်း ကစားမည့်ပွဲများကို ဦးစားပေးရွေးချယ်ပါ.",
  select_market_type: "သင်ကစားမည့် ပေါက်ကြေးအမျိုးအစားကို ရွေးချယ်ပါ.",
  select_page_size: "စာမျက်နှာ အရွယ်အစား ရွေးချယ်ပါ.",
  change_sports_menu_order: "ကိုယ်နှစ်သက်သည့် ပွဲစဥ်များအား ဖိထားပြီး အပေါ်အောက် ပြောင်းရွှေ့နိုင်သည် .",
  view_outstanding_bets_in_bet_list: "အသစ်ဆော့ထားသည့် ပွဲများ မပြီးဆုံးသေးပါက မိမ်၏ လောင်းကြေးဇယားတွင် ဝင်ရောက် ကြည့်ရှု့နိုင်သည်.",
  time_display_in_gmt_plus_8: "GMT+8 အချိန်ဖြင့် ဖော်ပြထားသည်.",
  select_default_stake: "မိမိလောင်းလိုသော ငွေပမာဏအား အမြဲတမ်းလောင်းကြေးငွေအဖြစ် သတ်မှတ်ထားနိုင်သည် ။ နောက်ဆုံးလောင်းထားသော လောင်းကြေးငွေကိုလဲ အမြဲတမ်းလောင်းကြေးငွေအဖြစ် သတ်မှတ်ထားနိုင်သည်။.",
  bet_empty: "လောင်းထားသော ကစားပွဲများ မရှိပါ ၊ ကျေးဇူးပြု၍ သင်လောင်းလိုသော ကစားပွဲအား ဇယားတွင် နှိပ်၍ လောင်းနိုင်ပါသည်.",
  no_event: "ကစားပွဲများမရှိသေးပါ ၊ ကျေးဇူးပြု၍ အခြားကစားနည်းများအား သွားရောက်ကစားပါ (သို့) နောက်မှပြန်လာပါ",
  no_bets: "လောင်းထားခြင်းမရှိပါ",
  no_waiting: "စောင့်ဆိုင်းနေသော လောင်းကြေးမရှိပါ",
  no_void: "ဖျက်သိမ်းခံရသော လောင်းကြေးမရှိပါ",
  confirmation: "‌လောင်းကြေးငွေထည့်ရန် သေချာပြီလား?",
  olderversion: "ဗားရှင်းအသစ်ထွက်ပါသဖြင့် Ok နှိပ်၍ အသစ်မြှင့်တင်ပါ (သို့) Ctrl +5 နှိပ်၍ မြှင့်တင်ပါ.",
  gmt8: "GMT+8 အချိန်ဖြင့် ဖော်ပြထားသည်.",
  confirm_bet: "လောင်းရန် အတည်ပြုပါ?",
  match_not_started: "ကစားပွဲ မစသေးပါ",
  odds_changed: "ပေါက်ကြေးပြောင်းလဲသွားသည်",
  ldiff_changed: "ပေါက်ကြေးပြောင်းလဲသွားသည်",
  to: "သို့",
  dnsta: "ထပ်မပြရန်.",

  login2: "ကစားရန် အကောင့်မရှိပါ Register ပြုလုပ်ပါ  ၊ အကောင့်ရှိသူများ  Login ဝင်ပါ.",

  no_video: "ဗီဒီယို ရှာလို့မတွေ့ပါ %%",

  button_skip: "ချက်ရန်ရန်ကျော်လွန်းရန်",
  button_previous: "နောက်သို့",
  button_next: "နောက်ထပ်",
  button_stop: "ပြီးဆုံး",
  button_continue: "ဆက်လက်ရှိရန်",

};
